<template>
  <span
    class="bordered-team"
    :class="[{ 'is-full': isFull }, { 'is-hidden-avatar': hideAvatar }]"
  >
    <slot name="avatar">
      <Avatar
        v-if="!hideAvatar"
        :src="src"
        type="teamsGroup"
        size="sm"
        bordered
      />
    </slot>
    <span
      v-if="isFull"
      class="bordered-team-name"
    >
      {{ teamName }}
    </span>
    <slot name="after-name" />
  </span>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import Avatar from "@/components/Avatar/index.vue"

const components = {
  Avatar
}

@Options({
  name: "BorderedTeam",
  components
})
export default class extends Vue {
  @Prop({ default: null }) readonly src: string | null
  @Prop({ default: true }) readonly isFull: boolean
  @Prop({ default: "" }) readonly teamName: string
  @Prop({ default: false }) readonly hideAvatar: boolean
}
</script>
